module.exports = __webpack_public_path__ + "static/media/arrowRightNew.0621c261.svg";